import { HiMiniStar } from 'react-icons/hi2'

export function MetricsCard({ metrics, value }) {
	const isNumber = typeof value === 'number'
	const hasMetrics = Array.isArray(metrics) && metrics.length > 0

	return (
		<div>
			<div className='tw-flex tw-items-center tw-mb-6'>
				<p className='tw-text-3xl tw-font-bold tw-text-gray-800 tw-mr-3'>{isNumber ? value.toFixed(1) : '-'}</p>
				<div className='tw-flex'>
					{isNumber &&
						[1, 2, 3, 4, 5].map(star => <HiMiniStar key={star} size={18} className={value < star ? 'tw-text-gray-200' : 'tw-text-alert-300'} />)}
				</div>
			</div>

			{hasMetrics ? (
				<div className='tw-grid tw-grid-cols-2 tw-gap-4'>
					{metrics.map((item, index) => (
						<div key={index} className='tw-flex tw-justify-between tw-items-center tw-text-gray-800 tw-text-sm'>
							<div className='tw-flex tw-items-center'>
								<span className='tw-mr-1'>🚩</span>
								<span>{item.name}</span>
							</div>
							<span className='tw-font-bold'>{item.value}%</span>
						</div>
					))}
				</div>
			) : (
				<p className='tw-text-gray-400 tw-text-sm'>No data</p>
			)}
		</div>
	)
}
